/**
 * 分发器对象
 *
 * 1.2017-01-10  rlair_解决因为dispatch分发冲突引起的所有bug
 *
 */
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import * as Flux from 'flux';

import Constants from 'utils/constants.jsx';

const PayloadSources = Constants.PayloadSources;

const AppDispatcher = Object.assign(new Flux.Dispatcher(), {
    handleServerAction: function performServerAction(action) {
        if (!action.type) {
            console.warn('handleServerAction called with undefined action type'); // eslint-disable-line no-console
        }

        var payload = {
            source: PayloadSources.SERVER_ACTION,
            action,
        };

        //解决因为dispatch分发冲突引起的所有bug
        setTimeout(() => {
            this.dispatch(payload);
        }, 0);
    },

    handleViewAction: function performViewAction(action) {
        if (!action.type) {
            console.warn('handleViewAction called with undefined action type'); // eslint-disable-line no-console
        }

        var payload = {
            source: PayloadSources.VIEW_ACTION,
            action,
        };

        //解决因为dispatch分发冲突引起的所有bug
        setTimeout(() => {
            this.dispatch(payload);
        }, 0);
    },
});

export default AppDispatcher;
